import { useTenant } from "./use-tenant";

/**
 * Mirrors the backend RLS write policies: a record is editable iff it is
 * owned by the user's own tenant (record_tenant_id = current_tenant_id()).
 * Global records therefore stay read-only for everyone except users of the
 * Global tenant, who own them.
 */
export function useRecordPermissions() {
  const { data, isLoading } = useTenant();
  const tenantId = data?.tenant?.tenant_id;

  // While tenant data is loading, treat records as read-only (safe default).
  const canEdit = (recordTenantId: string | null | undefined): boolean =>
    Boolean(tenantId && recordTenantId && recordTenantId === tenantId);

  return { tenantId, canEdit, isLoading };
}
